module.exports = __webpack_public_path__ + "static/tovifun_avatar-dcd5f246ca241a1528faf16e064c4d8d.png";